module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cw-collapse"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_c('div', {
    staticClass: "img-list"
  }, [_c('img', {
    attrs: {
      "src": _vm.listUrl,
      "width": "100%"
    }
  })]), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "show-more",
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_c('div', {
    staticClass: "arrow-text"
  }, [_c('span', {
    class: _vm.showMore ? 'arrow-up' : 'arrow-down'
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.showMore ? _vm.collapseText[1] : _vm.collapseText[0]))])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticClass: "content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41bd332a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Collapse/Collapse.vue
// module id = 844
// module chunks = 11